'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useRef } from 'react';
import { GTMPageView, trackTracardi } from '~/utils';

export function SharedScripts() {
  const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstRender = useRef(true);
  const lastTracardiPathname = useRef(pathname);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const url = searchParams.toString() ? `${pathname}?${searchParams.toString()}` : pathname;
    GTMPageView(url);
  }, [pathname, searchParams]);

  // The tracker snippet sends the first page view itself.
  useEffect(() => {
    if (lastTracardiPathname.current === pathname) return;
    lastTracardiPathname.current = pathname;
    trackTracardi('page-view');
  }, [pathname]);

  return (
    <>
      <Script id="gtm-loader" strategy="afterInteractive">
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`}
      </Script>

      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
        }}
      />

      <Script id="bing-tracking" strategy="lazyOnload">
        {
          '(function(w,d,t,r,u){var f,n,i; w[u]=w[u]||[],f=function(){var o={ti:" 97000996"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")}, n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){      var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)}, i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");'
        }
      </Script>
    </>
  );
}
